import React from 'react';
import { Box, Heading } from '@wix/design-system';
import { TemplateGalleryCard } from '@common/types';
import RecommendedTemplatesCarousel from '../RecommendedTemplatesCarousel';
import { RecommendedSectionType } from '../RecommendedTemplatesCarousel/RecommendedTemplatesCarousel';
import s from './RecommendedSection.module.scss';

interface RecommendedSectionProps {
  title: React.ReactNode;
  action?: React.ReactNode;
  templates: TemplateGalleryCard[];
  sectionType: RecommendedSectionType;
  dataHook: string;
  isMobileView?: boolean;
}

const RecommendedSection: React.FC<RecommendedSectionProps> = ({
  title,
  action,
  templates,
  sectionType,
  dataHook,
  isMobileView = false,
}) => {
  return (
    <Box
      direction="vertical"
      className={isMobileView ? s.mobileSectionContainer : s.sectionContainer}
      dataHook={dataHook}
    >
      <Box align="space-between">
        <Heading size={isMobileView ? 'medium' : 'large'} as="h2">
          {title}
        </Heading>
        {action}
      </Box>
      <Box marginTop="18px">
        <RecommendedTemplatesCarousel
          templates={templates}
          isMobileView={isMobileView}
          sectionType={sectionType}
        />
      </Box>
    </Box>
  );
};

export default RecommendedSection;
